import { useCallback, useContext, useEffect, useRef } from "react";
import { toast, ToastOptions } from "react-toastify";
import { WebSocketContext } from "../context/WebSocket/context";
import { deepCloneObject } from "../utils/deepClone";
import BatchIntegrationToast from "../components/BatchIntegrationToast";

export default function useBatchIntegrationNotification() {
  const { addHandler, removeHandler } = useContext(WebSocketContext);

  const toasts = useRef({});

  const unmountToasts = (brandId) => {
    const t = deepCloneObject(toasts.current);
    delete t[brandId];
    toasts.current = t;
  };

  const handler = useCallback(function handler(data: string) {
    const parsedData = JSON.parse(data);

    if (toasts.current[parsedData.brandId]) {
      const updateOptions = parsedData.message
        ? {
            render: parsedData.message,
            type: toast.TYPE.ERROR,
            closeOnClick: true,
            closeButton: true,
          }
        : parsedData.logId
        ? {
            render: BatchIntegrationToast(parsedData),
            closeOnClick: true,
            closeButton: true,
          }
        : {
            render: BatchIntegrationToast(parsedData),
            closeOnClick: false,
          };

      toast.update(toasts.current[parsedData.brandId], updateOptions);
    } else {
      const content = !parsedData.message
        ? BatchIntegrationToast(parsedData)
        : parsedData.message;

      const options = !parsedData.message
        ? {
            position: "top-right",
            autoClose: false,
            hideProgressBar: true,
            theme: "light",
            closeOnClick: false,
            closeButton: false,
          }
        : {
            type: toast.TYPE.ERROR,
            position: "top-right",
            autoClose: false,
            hideProgressBar: true,
            theme: "light",
            closeOnClick: true,
            closeButton: true,
          };

      const toastId = toast(content, options as ToastOptions);

      toasts.current = { ...toasts.current, [parsedData.brandId]: toastId };
    }

    if (!!parsedData.logId || !!parsedData.message) {
      unmountToasts(parsedData.brandId);
    }
  }, []);

  useEffect(() => {
    const uuid = crypto.randomUUID();
    addHandler(uuid, handler, "updateIntegrationSyncData");
    return () => removeHandler(uuid);
  }, [addHandler, removeHandler, handler]);
}
